import React from 'react';

import clsx from 'clsx';
import { ToastContainer as ContainerToast } from 'react-toastify';

import { ClearIcon } from 'components/common/Icons/Icons';

import styles from './ToastContainer.module.scss';

const ToastContainer = () => {
  return (
    <ContainerToast
      className={clsx(styles.toastContainer)}
      position="bottom-center"
      autoClose={5000}
      hideProgressBar
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      closeButton={() => <ClearIcon className={styles.toastCloseButton} />}
    />
  );
};

export default ToastContainer;
